// extracted by mini-css-extract-plugin
module.exports = {"WorldImg":"src-components-Main-Infos-WorldModal-WorldInfo-WorldImg-WorldImg--eAsNt"};